import { DataSourceIDEnum } from '@/models/dataSource';
import { StorageType } from '@/services/dataSources';

// CSV_FILE/ENCRYPTED_CSV_FILE map to 'csv' for reuse by the comuni resync flow (POST .../csv/resync).
// This does NOT surface the datasource-detail resync button for CSV: that button's visibility in
// DataSourceDetailHeader.tsx is gated by a separate hardcoded `type.id === SFTP || AmazonS3` check,
// not by this map, so widening it here is safe.
export const RESYNCABLE_DATA_SOURCES: Record<DataSourceIDEnum, StorageType | null> = {
  AMAZON_S3: 's3',
  SFTP: 'sftp',
  CSV_FILE: 'csv',
  ENCRYPTED_CSV_FILE: 'csv',
  GOOGLE_TAG_MANAGER: null,
  SALESFORCE: null,
  WEBSITE_JS: null,
  WORDPRESS: null,
  D365_BUSINESS_CENTRAL: null,
  SHOPIFY: null,
};
